const config = {
    civicIdentityStoreEndpoint: "https://api.civic.com/identity-store",
    ipfsMainGateway: "https://civic.infura-ipfs.io/ipfs/",
    passLookupEndpoint: "https://api.civic.com/pass-lookup",
};
export default config;
